import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    limitedCompanyName: {
        id: '_.your_company.limited_company_name',
        defaultMessage: 'Limited company name'
    },
    tradingName: {
        id: '_.your_company.trading_name',
        defaultMessage: 'Trading name'
    },
    companyType: {
        id: '_.your_company.company_type',
        defaultMessage: 'Company type'
    },
    website: {
        id: '_.your_company.website',
        defaultMessage: 'Website'
    },
    websitePlaceholder: {
        id: '_.your_company.website_placeholder',
        defaultMessage: 'www.example.com'
    },
    industry: {
        id: '_.your_company.industry',
        defaultMessage: 'Industry'
    },
    lastTwelveMonthsTurnover: {
        id: '_.your_company.last_twelve_months_turnover',
        defaultMessage: 'Last 12 months turnover'
    },
    annualProfit: {
        id: '_.your_company.annual_profit',
        defaultMessage: 'Last 12 months profit (before tax)'
    },
    businessTrading: {
        id: '_.your_company.business_trading',
        defaultMessage: 'When did your business start trading?'
    },
    cantFindYourCompany: {
        id: '_.your_company.cant_find_your_company',
        defaultMessage: `Can't find your company?`
    },
    enterManually: {
        id: '_.your_company.enter_manually',
        defaultMessage: 'Enter it manually'
    },
    searchForYourCompanyAutomatically: {
        id: '_.your_company.search_for_your_company_automatically',
        defaultMessage: 'Search for your company automatically'
    },
    enterAnnualTurnover: {
        id: '_.your_company.error.enter_annual_turnover',
        defaultMessage: 'Please enter your annual turnover'
    },
    enterTradingFrom: {
        id: '_.your_company.error.enter_trading_from',
        defaultMessage: 'Please enter the date you began trading'
    },
    enterAnnualProfit: {
        id: '_.your_company.error.enter_annual_profit',
        defaultMessage: 'Please enter your annual profit'
    }
});
